module.exports = __webpack_public_path__ + "static/media/Compliance Order - Lynphyl Homes Ltd. - March 21, 2024.31f59d82.pdf";